import { createFileRoute } from '@tanstack/react-router';
import {
  loadSystemApplicationMessages,
  loadSystemApplicationScreens,
  systemApplicationDetailScreen,
  systemApplicationDetailSearch,
} from '@/modules/system-application/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/seguranca/usuarios-aplicacao/$aplicacaoId/')({
  validateSearch: systemApplicationDetailSearch,
  staticData: { screen: systemApplicationDetailScreen },
  loader: () => loadSystemApplicationMessages(),
  component: lazyScreen(loadSystemApplicationScreens, 'SystemApplicationFormPage'),
});
